import { handleActions } from 'redux-actions';

import { resourceUpserters } from 'app-components/flux/core';
import { coreActions } from 'app-components/flux/core-actions';

import * as actions from './featureFlagsActions';
import { mkFeatureFlagsStore } from './featureFlagsTypes';

let dangerouslyUseFeatureFlags;
export const getDangerouslyUseFeatureFlags = () => dangerouslyUseFeatureFlags;

const reducer = handleActions(
  {
    [coreActions.PERSIST_DATA_LOAD_COMPLETE]: (state) =>
      state.merge({
        featureFlags: state.featureFlags.set('ldHasDatasetId', false), // session level flag
      }),

    [actions.getFeatureFlags]: (state) =>
      state.merge({
        isLoading: true,
        error: undefined,
      }),

    [actions.applyFeatureFlagsChanges]: (state, { payload: flags }) => {
      const featureFlags = state.featureFlags
        .withMutations((map) => Object.entries(flags).forEach(([key, value]) => map.set(key, value)))
        .sort();
      dangerouslyUseFeatureFlags = featureFlags;
      return state.merge({
        isLoading: false,
        loadPending: false,
        error: undefined,
        featureFlags,
      });
    },

    [actions.getFeatureFlagsSuccess]: (state, { payload: flags, meta, asyncDispatch }) => {
      asyncDispatch(actions.applyFeatureFlagsChanges(flags, meta));
      return state.merge({
        isLoading: false,
        loadPending: false,
        error: undefined,
      });
    },

    [actions.getFeatureFlagsFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),
  },
  mkFeatureFlagsStore(),
);

export default reducer;
